<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="슥삭" />
            <Navbar></Navbar>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container v-if="userinfo.authAdmin == 2" fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 rem-2 text-left">새로운 대학교 요청한 사용자 조회</span>
                            </v-row>
    
                            <v-row v-if="userList != null && userList.length == 0" class="mt-5">
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">해당 사용자가 없습니다.</span>
                            </v-row>
    
                            <v-row v-if="userList != null && userList.length > 0" class="mt-5">
                                <v-simple-table class="mx-auto">
                                    <thead>
                                        <th>번호</th>
                                        <th>닉네임</th>
                                        <th>대학교</th>
                                        <th>학과</th>
                                        <th>로그인날짜</th>
                                        <th>가입날짜</th>
                                    </thead>
                                    <tbody>

                                        <tr v-for="(user, index) in userList">
                                            <td class="text-left">
                                                {{user.userIdx}}
                                            </td>
                                            <td class="text-left">
                                                {{user.userNickname}}
                                            </td>
                                            <td class="text-left">
                                                {{user.userUniv}}
                                            </td>
                                            <td class="text-left">
                                                {{user.userMajor}}
                                            </td>
                                            <td class="text-left">
                                                {{user.lastLoginTime}}
                                            </td>
                                            <td class="text-left">
                                                {{user.userSignInDate}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>

                            </v-row>

                        </v-container>

                        <v-container v-else-if="userinfo.authAdmin != 2" fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">권한이 없습니다. 로그인 해주세요.</span>
                            </v-row>
                        </v-container>

                        <v-container v-else fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">로딩중...</span>
                            </v-row>
                        </v-container>
                        <Footer></Footer>
                    </v-flex>
                </v-layout>
    
            </v-container>

    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()

        this.getInvalidUsers()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 2,
            window: {
                width: 0,
                height: 0
            },
            ismobile: false,
            drawer: false,
            group: null,

            userList: [],

        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        },
        getInvalidUsers() {
            this.$http.get('/api/users/invalidUniv')
                .then((response) => {
                    if (response.data.status == 200) {
                        this.userList = response.data.data.userList
                    } else {
                        alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                        this.$store.dispatch('postLogout')
                    }
                })
        },
    }
}
</script>

<style lang="css">

</style>


// WEBPACK FOOTER //
// src/pages/AllInvalidUsers.vue